export const translations = {
  en: {
    nav: {
      about: "About",
      howToBuy: "How to Buy",
      story: "Story",
      roadmap: "Roadmap",
      tokenomics: "Tokenomics",
      copyContract: "Copy Contract",
      buyNow: "BUY NOW",
      copied: "Copied",
    },
    about: {
      title: "ABOUT US",
      paragraph1:
        "Nailong represents joy, playful chaos, and unstoppable cuteness a character that captured millions of hearts worldwide. We're channeling that same spirit into a community-driven token built around positivity, creativity, and shared culture.",
      paragraph2:
        "This isn't just a coin. It's Milk Dragon energy reimagined for the digital age.",
      ca: "CA : Coming Soon",
      copyContract: "Copy Contract",
    },
    footer: {
      socials: "Socials",
      rights: "© 2026 Nailong ($奶龙). All rights reserved.",
      rightsMobile: "© 2026 Nailong ($奶龙).",
      rightsMobileLine2: "All rights reserved.",
    },
    tokenomics: {
      header: "Contract & Token Info",
      copy: "Copy",
      ticker: "Ticker",
      chain: "Chain",
      copied: "Copied!",
    },
    beforeFooter: {
      heading: "Stay Connected",
    },
    exchange: {
      heading: "Find Bread 'N' Butter on the following Major Exchanges (Coming Soon)",
    },
    marquee: {
      text: "Milk Dragon is Rising",
    },
    videoGallery: {
      title: "Milk Dragon Moments",
      subtitle: "Watch the cuteness in motion",
    },
    story: {
      title: "The Tale of 奶龙",
      p1: "In the Milky Cloud Kingdom, a tiny yellow dragon named 奶龙 drifted through the sky on fluffy cream clouds, dreaming of sharing joy with everyone below.",
      p2: "Wherever 奶龙 flapped its little wings, milky stardust rained down, turning worries into giggles and bad days into soft, cozy moments.",
      p3: "One day, 奶龙 discovered a magical carton of cosmic milk that shimmered like the sunrise. With a single sip, 奶龙's powers bloomed, and a new legend was born: the Milk Dragon who guarded warm hearts and comfy vibes across the universe.",
      p4: "Now that magic lives on as 奶龙 Milk Dragon — a playful spirit of comfort, cuteness, and cozy chaos for everyone who joins the journey.",
    },
    howToBuy: {
      title: "HOW TO BUY",
      faqs: [
        {
          title: "Create a Solana Wallet",
          content:
            "Download Phantom or Solflare wallet from the App Store or Google Play. For desktop, install the Phantom browser extension to securely manage your SOL and $奶龙.",
        },
        {
          title: "Get Some SOL",
          content:
            "Purchase SOL from an exchange and transfer it to your wallet. Make sure to keep a small amount for transaction fees before swapping for $奶龙.",
        },
        {
          title: "Connect to a DEX",
          content:
            "Visit a Solana decentralized exchange like Jupiter or Raydium. Connect your wallet securely using the official website.",
        },
        {
          title: "Swap SOL for $奶龙",
          content:
            "Paste the official $奶龙 contract address, confirm the swap, and welcome to the Milk Dragon family. Your $奶龙 tokens will appear in your wallet instantly.",
        },
      ],
    },
    roadmap: {
      title: "ROADMAP",
      phases: [
        {
          title: "Phase 1",
          items: [
            "Token creation on Solana",
            "Website & branding release",
            "Community channels launch (X, Discord)",
            "Fair launch",
            "Initial liquidity setup",
          ],
        },
        {
          title: "Phase 2",
          items: [
            "Solana ecosystem listings (DEXs & trackers)",
            "Influencer and creator partnerships",
            "Community contests & rewards",
            "Marketing expansion",
          ],
        },
        {
          title: "Phase 3",
          items: [
            "Apply for major Solana based exchange listings",
            "Strategic partnerships",
            "Limited-edition merchandise drop",
            "Community reward programs",
          ],
        },
        {
          title: "Phase 4",
          items: [
            "Utility development within the Solana ecosystem",
            "Ecosystem collaborations",
            "Holder benefits & exclusive access programs",
            "Continuous development & brand growth",
          ],
        },
      ],
    },
    language: {
      label: "Language",
      zh: "中文",
      en: "English",
    },
  },
  zh: {
    nav: {
      about: "关于",
      howToBuy: "如何购买",
      story: "故事",
      roadmap: "路线图",
      tokenomics: "代币经济",
      copyContract: "复制合约",
      buyNow: "立即购买",
      copied: "已复制",
    },
    about: {
      title: "关于我们",
      paragraph1:
        "奶龙代表着欢乐、顽皮的混乱和势不可挡的可爱——一个风靡全球、俘获无数人心的角色。我们将同样的精神注入围绕正能量、创意和共同文化的社区驱动代币。",
      paragraph2: "这不仅是一枚代币，更是奶龙能量在数字时代的重新演绎。",
      ca: "合约地址：即将公布",
      copyContract: "复制合约",
    },
    footer: {
      socials: "社交媒体",
      rights: "© 2026 奶龙 Nailong ($奶龙)。保留所有权利。",
      rightsMobile: "© 2026 奶龙 Nailong ($奶龙)。",
      rightsMobileLine2: "保留所有权利。",
    },
    tokenomics: {
      header: "合约与代币信息",
      copy: "复制",
      ticker: "代币符号",
      chain: "链",
      copied: "已复制！",
    },
    beforeFooter: {
      heading: "保持联系",
    },
    exchange: {
      heading: "在以下主流交易所找到 Bread 'N' Butter（即将上线）",
    },
    marquee: {
      text: "奶龙崛起",
    },
    videoGallery: {
      title: "奶龙瞬间",
      subtitle: "萌动瞬间，尽收眼底",
    },
    story: {
      title: "奶龙的故事",
      p1: "在奶云王国里，一只名叫奶龙的小黄龙乘着蓬松的奶油云在天空中飘荡，梦想着把欢乐带给地上的每一个人。",
      p2: "奶龙所到之处，奶香星尘洒落，把烦恼变成欢笑，把糟糕的日子变成温暖柔软的时刻。",
      p3: "有一天，奶龙发现了一盒像晨曦一样闪耀的宇宙魔法奶。喝下一口，奶龙的力量绽放，新的传说诞生：守护温暖心灵与舒适氛围的奶龙，遍布宇宙。",
      p4: "如今，这份魔法化身为奶龙 Milk Dragon——为每一位加入旅程的人带来慰藉、可爱与温馨热闹的活力之灵。",
    },
    howToBuy: {
      title: "如何购买",
      faqs: [
        {
          title: "创建 Solana 钱包",
          content:
            "从 App Store 或 Google Play 下载 Phantom 或 Solflare 钱包。电脑端可安装 Phantom 浏览器扩展，安全管理您的 SOL 和 $奶龙。",
        },
        {
          title: "获取 SOL",
          content:
            "在交易所购买 SOL 并转入您的钱包。兑换 $奶龙 前请预留少量 SOL 用于支付手续费。",
        },
        {
          title: "连接 DEX",
          content:
            "访问 Jupiter 或 Raydium 等 Solana 去中心化交易所，通过官网安全连接您的钱包。",
        },
        {
          title: "用 SOL 兑换 $奶龙",
          content:
            "粘贴官方 $奶龙 合约地址，确认兑换，欢迎加入奶龙大家庭。您的 $奶龙 将立即出现在钱包中。",
        },
      ],
    },
    roadmap: {
      title: "路线图",
      phases: [
        {
          title: "第一阶段",
          items: [
            "在 Solana 上创建代币",
            "官网与品牌发布",
            "社区渠道上线（X、Discord）",
            "公平发射",
            "初始流动性配置",
          ],
        },
        {
          title: "第二阶段",
          items: [
            "Solana 生态上架（DEX 与追踪器）",
            "KOL 与创作者合作",
            "社区竞赛与奖励",
            "市场推广扩展",
          ],
        },
        {
          title: "第三阶段",
          items: [
            "申请主流 Solana 交易所上架",
            "战略合作",
            "限量周边发售",
            "社区奖励计划",
          ],
        },
        {
          title: "第四阶段",
          items: [
            "Solana 生态内应用开发",
            "生态合作",
            "持币福利与专属权益",
            "持续开发与品牌成长",
          ],
        },
      ],
    },
    language: {
      label: "语言",
      zh: "中文",
      en: "English",
    },
  },
};

export function getT(lang) {
  const strings = translations[lang] || translations.zh;
  return function t(path) {
    const keys = path.split(".");
    let value = strings;
    for (const k of keys) {
      value = value?.[k];
    }
    return value ?? path;
  };
}
